import { render, staticRenderFns } from "./damagedPiece.pug?vue&type=template&id=be424ce8&lang=pug&external"
import script from "./damagedPiece.js?vue&type=script&lang=js&external"
export * from "./damagedPiece.js?vue&type=script&lang=js&external"
import style0 from "./damagedPiece.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be424ce8')) {
      api.createRecord('be424ce8', component.options)
    } else {
      api.reload('be424ce8', component.options)
    }
    module.hot.accept("./damagedPiece.pug?vue&type=template&id=be424ce8&lang=pug&external", function () {
      api.rerender('be424ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damagedPiece/index.vue"
export default component.exports